import { Controller } from "@hotwired/stimulus"

// オーバーレイ内のフォーム送信を外側ボタンから委譲する
// data-modal-submit-form-selector-value で対象フォームを指定可能
export default class extends Controller {
  static values = { formSelector: String }

  submit(event) {
    event.preventDefault()

    const scope = this.element.closest("[data-controller~='modal'], [data-controller~='offcanvas']") || document
    const form = this.hasFormSelectorValue
      ? scope.querySelector(this.formSelectorValue)
      : scope.querySelector("form")

    form?.requestSubmit()
  }
}
